/*
 * Copyright (C) Ivo Ladage-van Doorn - All Rights Reserved
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Ivo Ladage-van Doorn <ivol37@gmail.com>, 2024
 */

type Video = {
  year: number;
  name: string;
  format: string;
  length: string;
  size: string;
  download: string;
};

function Videos() {
  const videoTable = (videos: Video[]) => {
    return (
      <div className="table-container">
        <table>
          <thead>
            <tr>
              <th>Jaar</th>
              <th className="left">Naam</th>
              <th>Formaat</th>
              <th>Lengte</th>
              <th>Grootte</th>
              <th>Download</th>
            </tr>
          </thead>
          <tbody>
            {videos.map((video: Video, index: number) => {
              return (
                <tr key={index}>
                  <td>{video.year}</td>
                  <td className="left">{video.name}</td>
                  <td>{video.format}</td>
                  <td>{video.length}</td>
                  <td>{video.size}</td>
                  <td>
                    <a href={video.download} target="_new">
                      Link
                    </a>
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    );
  };

  const video = (year: number, name: string, format: string, length: string, size: string, download: string) => {
    return {
      year: year,
      name: name,
      format: format,
      length: length,
      size: size,
      download: download,
    };
  };

  return (
    <div>
      <div className="box light">
        <div className="row">
          <h1>Videos</h1>
          <p>
            In onderstaande tabel zijn de Lekkveld gerelateerde video's te vinden die ik in het verleden gemaakt heb. Om de video's te kunnen downloaden moet je dezelfde
            gebruikersnaam en wachtwoord inloggen als bij Foto's (dus als je die niet weet; kijk onder het kopje "Foto's").
          </p>
          {videoTable([
            video(1997, "DESDA", "mpeg", "1:13:29", "4,24 GB", "https://gofile.me/3eJea/hDrAnCUay"),
            video(2001, "Sinterklaas Tolhuis", "mpeg", "00:47:02", "1,47 GB", "https://gofile.me/3eJea/tpWBYmwEi"),
            video(2001, "Sosoye en Tours-sur-Marne", "mpeg", "1:01:58", "3,58 GB", "https://gofile.me/3eJea/ni4k3BO1E"),
            video(2001, "Verjaardag Ivo", "mpeg", "00:05:30", "176 MB", "https://gofile.me/3eJea/OzvMwR2If"),
            video(2002, "Dasburg", "mpeg", "00:29:40", "1,31 GB", "https://gofile.me/3eJea/uRRvk0hvN"),
            video(2003, "Nommern", "mpeg", "00:53:16", "1,65 GB", "https://gofile.me/3eJea/eTsGSHcxJ"),
            video(2003, "Verjaardag Ivo", "mpeg", "00:57:39", "1,80 GB", "https://gofile.me/3eJea/1voLgLsIZ"),
            video(2004, "30ste verjaardag Ivo", "mpeg", "00:04:30", "144 MB", "https://gofile.me/3eJea/JYRf8U6S4"),
            video(2004, "Sinterklaas Oss", "mpeg", "00:08:35", "272 MB", "https://gofile.me/3eJea/5XWmfKHj9"),
            video(2005, "Zomervakantie Belgie Morville", "mpeg", "00:51:54", "1,62 GB", "https://gofile.me/3eJea/0qwe2uzyd"),
            video(2006, "Ovifat", "mpeg", "00:08:02", "258 MB", "https://gofile.me/3eJea/iiYO5354r"),
            video(2007, "Titania Trailer", "mpeg", "00:03:04", "98,2 MB", "https://gofile.me/3eJea/RVHUGyNOg"),
            video(2007, "Titania", "mpeg", "01:13:25", "2,28 GB", "https://gofile.me/3eJea/0tmtD9nvF"),
            video(2007, "Titania extended", "mpeg", "02:49:48", "5,29 GB", "https://gofile.me/3eJea/eHa8eB4xF"),
            video(2009, "Stolis Trailer", "mpeg", "00:03:23", "133 MB", "https://gofile.me/3eJea/UW1K8e4Yx"),
            video(2009, "Stokis", "mpeg", "00:52:04", "3,00 GB", "https://gofile.me/3eJea/RHDXx7BsC"),
            video(2010, "Vielsalm", "mpeg", "01:05:41", "7,34 GB", "https://gofile.me/3eJea/dz0h5RCxl"),
            video(2011, "Vlessart", "mpeg", "00:39:55", "4,46 GB", "https://gofile.me/3eJea/hM6cJvVRR"),
            video(2014, "Niedersorpe Trailer", "mpeg", "00:03:11", "602 MB", "https://gofile.me/3eJea/N7mfGy9Ar"),
            video(2014, "Niedersorpe", "mpeg", "00:54:46", "10,0 GB", "https://gofile.me/3eJea/vZqEmCVQk"),
            video(2015, "Ovifat Trailer", "mpeg", "00:02:09", "487 MB", "https://gofile.me/3eJea/I4F46h0VG"),
            video(2015, "Ovifat", "mpeg", "00:48:17", "10,6 GB", "https://gofile.me/3eJea/SKwuXicux"),
            video(2018, "Sint Gervais Trailer", "mpeg", "00:02:22", "339 MB", "https://gofile.me/3eJea/PspAZ6tIC"),
            video(2018, "Sint Gervais", "mpeg", "00:22:37", "14,16 GB", "https://gofile.me/3eJea/drDxVaYPV"),
            video(2020, "Widmol Seizoen 1 - Aankondiging", "mpeg", "00:01:52", "159 MB", "https://gofile.me/3eJea/AVJ9HNTeD"),
            video(2021, "Widmol Seizoen 1 - Ontknoping", "m4v", "00:11:48", "544 MB", "https://gofile.me/3eJea/TsWpcrlN4"),
            video(2022, "Widmol Seizoen 2 - Molhints", "m4v", "00:07:30", "1,38 GB", "https://gofile.me/3eJea/UAKpkb56j"),
            video(2022, "Widmol Seizoen 2 - Ontknoping", "m4v", "00:06:28", "120 MB", "https://gofile.me/3eJea/9fidAHEGH"),
            video(2022, "Widmol Seizoen 2 - Opdracht 1 tm 5", "m4v", "01:00:31", "1,34 GB", "https://gofile.me/3eJea/GjY6sms8g"),
            video(2022, "Widmol Seizoen 2 - Opdracht 6 tm 9", "m4v", "00:58:02", "1,22 GB", "https://gofile.me/3eJea/n01QnWEmQ"),
          ])}
        </div>
      </div>
    </div>
  );
}

export default Videos;
